module.exports = __webpack_public_path__ + "img/head2.50f44001.png";